export const getVersion = () => {
    return '1.0.6';
};
